// Import React Systems
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { onSnapshot, doc } from "firebase/firestore";
import { db } from "../../../../backend/firebaseConfig";
import { getAuth } from "firebase/auth";

// Import Atoms
import Icon from "../../atoms/icon/Icon"
import Text from "../../atoms/text/Text"

// Imports MUI Components
import {  Box,
          Stack,
          Avatar } from "@mui/material"

// Import Assets
import user from "../../../../assets/user.png"
import camera from "../../../../assets/camera.png"

// Import Functions
import { fetchUserDetails } from "../../../functions/fetchUserDetails"

const SidebarUserProfile = ({ 
  name, 
  email,
  open 
}) => {

  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) return;

    // Listen for real-time updates to the user's profile
    const userDocRef = doc(db, "users", currentUser.uid);
    const unsubscribe = onSnapshot(
      userDocRef,
      (snapshot) => {
        if (snapshot.exists()) {
          setUserDetails(snapshot.data());
        } else {
          setUserDetails(null);
        }
      },
      (error) => {
        if (error?.code !== "permission-denied") {
          console.error("Error listening to user profile:", error);
        }
        setUserDetails(null);
      }
    );

    return () => unsubscribe();
  }, []);

  // UseEffects
  useEffect(() => {
    const details = fetchUserDetails(setUserDetails);
    return () => {
      details && details();
    };
  }, []);

  const displayName =
    [userDetails?.firstName, userDetails?.lastName]
      .filter(Boolean)
      .join(" ")
      .trim() ||
    (name && name.trim() !== "" ? name : "Patient");

  const displayContact =
    userDetails?.email ||
    userDetails?.mobile ||
    (email && email.trim() !== "" ? email : "No contact info");

  return (
    <div>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "center",
          alignItems: "center",
          mb: 1
        }}
      >
        {userDetails?.profilePictureUrl ? (
          <>
            <Avatar
              alt="Profile"
              sx={{
                width: "50px",
                height: "50px",
                border:"3px solid #59544A",
                backgroundColor: "black"
              }}
              src={userDetails?.profilePictureUrl}
            />
          </>
        ) : (
          <>
            <Avatar
              alt="Profile"
              sx={{
                width: "50px",
                height: "50px",
                border:"3px solid #59544A",
                backgroundColor: "#2C251E"
              }}>
                <Icon
                  src={user}
                  size="small"/>
            </Avatar>
          </>
        )}
        
        {open &&
        <Box>

          <Text
            text={displayName}
            variant="h4Light"/>

          <Text
            text={displayContact}
            variant="h5"/>
                  
        </Box>
        }

      </Stack>
    </div>
  );
};

export default SidebarUserProfile;